import $ from "jquery";
import React from "react";
import { Row, Column } from "react-foundation";
import ColourChip from "./ColourChip";

import "css/ChipsGrid.css";
import SlickSlider from "./SlickSlider";

const ChipsGrid = ({ colours, selectedId, onChange, chipsPerRow }) => {
    let sliderSettings = {
        slidesToShow: 4,
        centerMode: false,
        focusOnSelect: false,
        infinite: false,
        slidesToScroll: 3,
        centerPadding: "200px"
    };

    sliderSettings = {
        responsive: [{ breakpoint: 639, settings: sliderSettings }, { breakpoint: 1000000, settings: "unslick" }]
    };
    chipsPerRow = chipsPerRow || 4;

    return (
        <div className="ChipsGrid">
            {/* Small */}
            <div className="show-for-small-only" style={{ margin: "0px 10px" }}>
                <SlickSlider
                    values={colours}
                    settings={sliderSettings}
                    onChange={null}
                    onDisplay={value => <ColourChip src={value.externalImageUrl1} selected={value.id === selectedId} onClick={() => onChange(value.id)} text={""} />}
                />
            </div>
            {/* Medium+ */}
            <Row className="hide-for-small-only" upOnSmall={chipsPerRow}>
                {$.map(colours, (value, index) => {
                    let selected = value.id === selectedId;

                    return (
                        <Column key={index}>
                            <ColourChip
                                selected={selected}
                                text={value.description1 || value.description}
                                src={value.externalImageUrl1}
                                value={value}
                                onClick={() => onChange(value.id)}
                            />
                        </Column>
                    );
                })}
            </Row>
        </div>
    );
};

export default ChipsGrid;



// WEBPACK FOOTER //
// ./src/components/ChipsGrid.js